import Visualizer from './Visualizer/Visualizer';

const App = () => {
  return <Visualizer></Visualizer>;
};

export default App;
